<template>
  <div class="svg10" ref="svgTarget">
    <svg
      height="170"
      preserveAspectRatio="xMidYMid meet"
      width="170"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="group1">
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="77.75"
          stroke="black"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="69.75"
          stroke="black"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="61.75"
          stroke="black"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="53.75"
          stroke="black"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="45.75"
          stroke="black"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="white"
          r="37.75"
          stroke="black"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="29.75"
          stroke="white"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="21.75"
          stroke="white"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="13.75"
          stroke="white"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="5.75"
          stroke="white"
          stroke-width="0.5"
        />
        <circle
          cx="85"
          cy="85"
          fill="black"
          r="2.5"
          stroke="white"
          stroke-width="0.5"
        />
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="159.75">
          1
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="12.25">
          1
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="157.5" y="86.5">
          1
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="10" y="86.5">
          1
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="151.75">
          2
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="20.25">
          2
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="149.5" y="86.5">
          2
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="18" y="86.5">
          2
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="143.75">
          3
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="28.25">
          3
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="141.5" y="86.5">
          3
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="26" y="86.5">
          3
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="135.75">
          4
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="36.25">
          4
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="133.5" y="86.5">
          4
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="34" y="86.5">
          4
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="127.75">
          5
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="44.25">
          5
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="125.5" y="86.5">
          5
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="42" y="86.5">
          5
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="119.75">
          6
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="83.5" y="52.25">
          6
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="117.5" y="86.5">
          6
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="50" y="86.5">
          6
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="83.5" y="111.75">
          7
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="83.5" y="60.25">
          7
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="109.5" y="86.5">
          7
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="58" y="86.5">
          7
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="83.5" y="103.75">
          8
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="83.5" y="68.25">
          8
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="101.5" y="86.5">
          8
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="66" y="86.5">
          8
        </text>
      </g>
      <g v-for="(item, idx) in dataitem" :key="idx">
        <circle
          v-if="item.x != ''"
          :cx="centerPosition + item.x * 1"
          :cy="centerPosition - item.y * 1"
          :fill="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
          :r="bulletRadius"
          stroke="black"
          stroke-width="0.01"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 子弹半径
      bulletRadius: 2.25,
      // 中心点
      centerPosition: 85,
      // 靶面直径（0环大小）
      diameter: 147.5,
      // 初始缩放比率
      initScale: 2.5,
      // 负margin值 考虑面板大于显示框的情况
      marign: 0,
      // 设置每一环值放大倍数1-10环
      zoomSetting: [1,1,1,1,1,1,1,2,3,4.5,8]
    };
  },
  methods: {
    // 设置css原始属性值（放大倍数scale ，偏移量 margin）
    setProperty: function(attribute, val) {
      this.$refs.svgTarget?this.$refs.svgTarget.style.setProperty(attribute, val):"";
    },
    scaleZoom: function(newVal) {
      let idx = 0;
      if (newVal == "") {
        idx = 0;
      } else {
        idx = Math.floor(newVal / 1);
      }

      this.setProperty("--transScale", this.initScale * this.zoomSetting[idx]);
    }
  },
  mounted() {
    // 减去margin高度
    const parentContainerHeight =
      document.getElementsByClassName("targetContainer")[0].clientHeight;
    // -0.1杜绝1像素问题
    this.initScale = parentContainerHeight / this.diameter - 0.1;

    // // 考虑面板大于显示框的情况
    // if (parentContainerHeight < this.centerPosition * 2) {
    //   this.margin =
    //     (parentContainerHeight - this.centerPosition * 2) / 2 + "px";
    //   this.setProperty("--margin", this.margin);
    //   this.setProperty("--transScale", this.initScale);
    // } else {
    //   this.setProperty("--transScale", this.initScale);
    // }
    
    this.margin =
        (parentContainerHeight - this.centerPosition * 2) / 2 + "px";
      this.setProperty("--margin", this.margin);
      this.setProperty("--transScale", this.initScale);
    this.scaleZoom(this.lastscore);
  },
  watch: {
    lastscore: {
      handler: function(newVal) {
        this.scaleZoom(newVal);
      },
      immediate: true
    }
  },
  props: ["dataitem", "lastscore"]
};
</script>
<style lang="less" scoped>
.svg10 {
  flex: 1;
  display: flex;
  align-items: center;
  --transScale: 1;
  --margin: 0px;
  // overflow: hidden;
  position: absolute;
  svg {
    transform: scale(var(--transScale));
    margin-top: var(--margin);
  }
}
</style>
